
import { CardHeader } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RefreshCw, Store } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface RecommendedDealersHeaderProps {
  onRefresh: () => void;
  goldPurity?: string;
  onPurityChange?: (purity: string) => void;
  metal: "gold" | "silver"; // Add metal prop
}

export function RecommendedDealersHeader({ 
  onRefresh,
  goldPurity,
  onPurityChange,
  metal // Accept metal prop
}: RecommendedDealersHeaderProps) {
  // Get display text based on metal type
  const metalDisplayName = metal === "gold" ? "Oro" : "Argento";
  
  return (
    <CardHeader className="flex flex-row items-center justify-between">
      <div>
        <h3 className="text-lg font-semibold flex items-center">
          <Store className="h-5 w-5 mr-2 text-metal" />
          Compro {metalDisplayName} Consigliati
          {goldPurity && (
            <Badge variant="outline" className="ml-2 text-xs">
              {goldPurity}
            </Badge>
          )}
        </h3>
        <p className="text-sm text-muted-foreground">Le migliori quotazioni in tempo reale</p>
      </div>
      <Button variant="outline" size="icon" onClick={onRefresh} className="h-8 w-8">
        <RefreshCw className="h-4 w-4" />
      </Button>
    </CardHeader>
  );
}
